<template>
  <div>
    <van-nav-bar
      title="时时宝"
      left-text="返回"
      left-arrow
      @click-left="$router.push('/member/members')"
    />
    <van-pull-refresh v-model="isLoading" @refresh="onRefresh">
      <van-row >
        <van-col span="8"> </van-col>
        <van-col span="8">
          <div class="capital">
            <h5>当前资产</h5>
            <p>{{ amount }}元</p>
          </div>
        </van-col>
        <van-col span="8"
          ><div class="capital">
            <router-link to="/member/time_bao_details"
              ><h5 style="color: #1989fa">账单</h5></router-link
            >
          </div></van-col
        >
      </van-row>

      <van-row>
        <van-col span="8">
          <div class="capital">
            <h5>上8小时收益</h5>
            <p>{{ interestthis }}元</p>
          </div>
        </van-col>
        <van-col span="8">
          <div class="capital">
            <h5>累计收益</h5>
            <p>{{ interestamount }}元</p>
          </div>
        </van-col>
        <van-col span="8">
          <div class="capital">
            <h5>年化利率</h5>
            <p>{{ annual_interest_rate }}%</p>
          </div>
        </van-col>
      </van-row>
      <div class="capital-btn">
        <van-row>
          <van-col span="12">
            <van-button
              round
              type="danger"
              size="normal"
              @click="movein.status = true; movein.money=cash"
              style="height: 30px; width: 100px"
              >转入</van-button
            >
          </van-col>
          <van-col span="12">
            <van-button
              round
              type="info"
              size="normal"
              @click="moveout.status = true; moveout.money=amount"
              style="height: 30px; width: 100px"
              >转出</van-button
            >
          </van-col>
        </van-row>
      </div>
      <van-divider />
      <img :src="timebaoImage" style="width: 100%" />
    </van-pull-refresh>

    <!-- ==================== move IN confirm popup ========================== -->

    <van-dialog
      v-model="movein.status"
      title="转入时时宝"
      show-cancel-button
      :beforeClose="moveinBtn"
    >
      <van-row>
        <van-col span="6">
          <p style="padding-left: 15px; font-size: 14px">账户余额:</p>
        </van-col>
        <van-col span="12"
          ><p style="padding-left: 30px; font-size: 14px">
            {{ cash }}元
          </p></van-col
        >
      </van-row>
      <van-cell-group>
        <van-field
          type="number"
          v-model="movein.money"
          label="转入金额:"
          placeholder=""
        />
      </van-cell-group>
    </van-dialog>

    <!-- ==================== move OUT confirm popup ========================== -->

    <van-dialog
      v-model="moveout.status"
      title="从时时宝转出"
      show-cancel-button
      :beforeClose="moveoutBtn"
    >
      <van-row>
        <van-col span="6">
          <p style="padding-left: 15px; font-size: 14px">可转余额:</p>
        </van-col>
        <van-col span="12"
          ><p style="padding-left: 30px; font-size: 14px">
            {{ timebao_account }}元
          </p></van-col
        >
      </van-row>
      <van-cell-group>
        <van-field
          type="number"
          v-model="moveout.money"
          label="转出金额:"
          placeholder=""
        />
      </van-cell-group>
    </van-dialog>
  </div>
</template>

<script>
export default {
  name: "TimeBao",
  data() {
    return {
      isLoading: false,
      amount: 0,
      cash: 0,
      timebao_account: 0,
      interestthis: 0,
      interestamount: 0,
      annual_interest_rate: 0,
      timebaoImage: "",
      movein: {
        money: 0,
        status: false,
      },
      moveout: {
        money: 0,
        status: false,
      },
    };
  },
  computed: {},
  methods: {
    isLogin() {
      let that = this;
      if (!that.$store.state.loginType) {
        that.$router.push("/login");
      }
    },
    mainMethod() {
      this.getTimebaoFund();
      this.getUserinfo();
    },
    onRefresh() {
      this.mainMethod();
      this.isLoading = false;
    },
    getTimebaoFund() {
      let that = this;
      that
        .$http({
          url: "/",
          method: "post",
          data: {
            nozzle: "timebao_fund",
            token: sessionStorage.getItem("token"),
            action: "queryfund",
          },
        })
        .then(function (res) {
          if (res.data.code == 1) {
            let resData = res.data;
            // that.account = resData.data.account;
            that.amount = resData.data.account.amount;
            that.interestthis = resData.data.account.interestthis;
            that.interestamount = resData.data.account.interestamount;
            that.timebaoImage = resData.data.image;
            that.annual_interest_rate = resData.data.annual_interest_rate;
          } else if (res.data.code == 0) {
            that.$message.error(res.data.msg);
          } else if (res.data.code == -1) {
            that.$logout(res.data.msg);
          }
        });
    },

    getUserinfo() {
      let that = this;
      that
        .$http({
          url: "/",
          method: "post",
          data: {
            nozzle: "user",
            token: sessionStorage.getItem("token"),
          },
        })
        .then(function (res) {
          if (res.data.code == 1) {
            that.cash = res.data.data.cash;
            that.movein.money = that.cash;
            that.timebao_account = res.data.data.timebao_accout;
            that.moveout.money = that.timebao_account;
          } else if (res.data.code == 0 || res.data.code == -1) {
            that.$message.error(res.data.msg);
          }
        });
    },

    moveinBtn(action, done) {
      let that = this;
      switch (action) {
        case "confirm":
          let money = that.movein.money;
          if (money == "" || money <= 0 || isNaN(money)) {
            this.$toast({
              type: "warning",
              message: "请输入正确金额",
            });
            done(false);
          } else {
            that
              .$http({
                url: "/",
                method: "post",
                data: {
                  nozzle: "timebao_fund",
                  token: sessionStorage.getItem("token"),
                  action: "movein",
                  amount: money,
                },
              })
              .then(function (res) {
                if (res.data.code == 1) {
                  that.$toast({
                    message: res.data.msg,
                    type: "success",
                    onClose: function () {
                      that.mainMethod();
                      that.movein.money = 0;
                      done();
                    },
                  });
                } else if (res.data.code == 0 || res.data.code == -1) {
                  that.$toast.fail(res.data.msg);
                  done(false);
                }
              });
          }

          break;
        case "cancel":
          done();
          break;
      }
    },

    moveoutBtn(action, done) {
      let that = this;
      switch (action) {
        case "confirm":
          let money = that.moveout.money;
          if (money == "" || money <= 0 || isNaN(money)) {
            this.$toast({
              type: "warning",
              message: "请输入正确金额",
            });
            done(false);
          } else {
            that
              .$http({
                url: "/",
                method: "post",
                data: {
                  nozzle: "timebao_fund",
                  token: sessionStorage.getItem("token"),
                  action: "moveout",
                  amount: money,
                },
              })
              .then(function (res) {
                if (res.data.code == 1) {
                  that.$toast({
                    message: res.data.msg,
                    type: "success",
                    onClose: function () {
                      that.mainMethod();
                      that.moveout.money = 0;
                      done();
                    },
                  });
                } else if (res.data.code == 0 || res.data.code == -1) {
                  that.$toast.fail(res.data.msg);
                  done(false);
                }
              });
          }
          break;
        case "cancel":
          done();
          break;
      }
    },
  },
  mounted() {
    this.getTimebaoFund();
    this.getUserinfo();
  },
};
</script>

<style scoped>
.navstyles {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
}

.capital {
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}

.capital h5 {
  margin: 0;
  font-size: 14px;
  font-weight: 300;
}

.capital p {
  margin: 0;
  color: red;
  font-size: 14px;
  font-weight: bold;
}

.capital-btn {
  margin-top: 10px;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/TimeBao.vue